import { z } from "zod";

export const voiceGuesserPlayerSchema = z.object({
	user_id: z.string(),
	display_name: z.string(),
	avatar_url: z.string().nullable(),
	joined_at: z.number(),
	score: z.number().int().nonnegative(),
	current_streak: z.number().int().nonnegative(),
	best_streak: z.number().int().nonnegative(),
	has_recording: z.boolean(),
});

export type VoiceGuesserPlayer = z.infer<typeof voiceGuesserPlayerSchema>;
